module.exports = __webpack_public_path__ + "static/media/firebase.d056dd34.png";